<template>
  <div class="right-panel">
    <div class="row mb-3">
      <div class="col col-xs-12 col-sm-8 form-input">
        <a title="Back to programs" href="#" @click="backToProgram"><i class="bi bi-arrow-left"></i></a>
        <span @click="backToProgram" class="back">Back</span>
      </div>
      <div class="col col-xs-6 col-sm-6">
        <h2>Select Participants to Email</h2>
        <h5>{{ route.params.programName }}</h5>
      </div>
      <div class="col col-xs-6 col-sm-6 text-right">
        <button class="btn btn-primary" :disabled="itemsSelected.length == 0" @click="onCreateEmail">
          Create email for selected
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-12 col-sm-3 form-input">
        <label for="basic-url">Search by Name</label>
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Enter first or last name"
            aria-label="Enter first or last name" @input="searchByNameDebounce" />
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <EasyDataTable must-sort v-model:items-selected="itemsSelected" v-model:server-options="serverOptions"
        table-class-name="datatable" :headers="headers" :items="items" :server-items-length="totalCount"
        :loading="isLoadingProgramParticipants" buttons-pagination :alternating="true" @expand-row=""
        class="data-table">
        <template #expand="item">
          <div class="pa-4">
            <div class="row pb-4">
              <div class="col">
                <b>Guardian name: </b>
                <span>{{ item.guardianName ?? "N/A" }}</span>
              </div>
              <div class="col">
                <b>Guardian phone: </b>
                <span>{{ item.guardianPhone ?? "N/A" }}</span>
              </div>
              <div class="col">
                <b>Email: </b>
                <span>{{ item.guardianEmail ?? "N/A" }}</span>
              </div>
              <div class="col">
                <b>Address: </b>
                <span>{{ item.address ?? "N/A" }}</span>
              </div>
              <div class="col">
                <b>Club hand: </b>
                <span>{{
                  item.playingHand ? (item.layingHand == "R" ? "Right" : "Left") : "N/A"
                }}</span>
              </div>
              <div class="col">
                <b>School: </b>
                <span>{{ item.school ?? "N/A" }}</span>
              </div>
            </div>
            <div class="row pb-4">
              <div class="col">
                <b>How did you find out about this program?: </b>
                {{ item.howFound ?? "N/A" }}
              </div>
              <div class="col">
                <b>Disability: </b>
                <span>{{ item.hasSpecialNeeds ? "Yes" : "No" }}</span>
              </div>
              <div class="col">
                <b>Disability comments: </b>
                <span>{{ item.specialNeedsComment ?? "N/A" }}</span>
              </div>
              <div class="col"></div>
              <div class="col"></div>
              <div class="col"></div>
            </div>
          </div>
        </template>
      </EasyDataTable>
    </div>
  </div>

  <Notification ref="notificationMsg" colorScheme="text-bg-success">
    <template #body>
      Successfully removed!
      <strong>{{ `${selectedItem?.firstName + " " + selectedItem?.lastName}` }}</strong>
    </template>
  </Notification>
</template>

<script setup lang="ts">
import type { Item, ServerOptions } from "vue3-easy-data-table";
import { ref, watch, onMounted, computed } from "vue";
import { useProgramStore } from "@/stores/program-store";
import { useEmailStore } from "@/stores/email-store";
import { debounce } from "lodash";
import Notification from "@/components/common/Notification.vue";
import router from "@/router";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
const route = useRoute();
const { getProgramParticipants } = useProgramStore();
const { participants, totalCount, isLoadingProgramParticipants } = storeToRefs(
  useProgramStore()
);

const itemsSelected = ref<Item[]>([]);
const selectedItem = ref();
const searchByName = ref();
let notificationMsg = ref<any | null>(null);

const programUID = computed(() => {
  return route.params.programUID as string;
});

const searchByNameDebounce = debounce(($event) => {
  if ($event.target.value && $event.target.value.length <= 2) return;
  searchByName.value = $event.target.value;
}, 500);

const items = ref<Item[]>([]);
const headers = [
  {
    text: "First Name",
    value: "firstName",
    sortable: true,
  },
  {
    text: "Last Name",
    value: "lastName",
    sortable: true,
  },
  {
    text: "Gender",
    value: "gender",
    sortable: true,
  },
  {
    text: "D.O.B",
    value: "dob",
    sortable: true,
  },
  {
    text: "Participation pack requested",
    value: "participantPackRequested",
    sortable: true,
  },
  {
    text: "Manually Created?",
    value: "isManuallyCreated",
    sortable: true,
  },
  {
    text: "",
    value: "buttons",
    sortable: false,
  },
];
const serverOptions = ref<ServerOptions>({
  page: 1,
  rowsPerPage: 20,
  sortBy: "dateCreated",
  sortType: "asc",
});

onMounted(async () => {
  await loadProgramParticipants();
});

const loadProgramParticipants = async () => {
  await getProgramParticipants(
    programUID.value,
    searchByName.value,
    serverOptions.value.page,
    serverOptions.value.rowsPerPage,
    serverOptions.value.sortBy,
    serverOptions.value.sortType
  );
  items.value = participants.value;
};

watch([searchByName, serverOptions], async () => {
  await loadProgramParticipants();
});

const backToProgram = async () => {
  await router.push({
    name: "Participation",
    query: route.query,
  });
};

const store = useEmailStore();
const onCreateEmail = async () => {
  //call store action to save data
  store.emailParticipationsParams(itemsSelected.value);

  await router.push({
    name: "ParticipationProgramSendEmail",
    params: {
      programUID: programUID.value,
    },
  });
};
</script>

<style scoped>
label.form-label {
  font-size: 13px;
}

.back {
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
}
</style>
